import { getApiBaseUrl } from "@/lib/api-base";
import { fetchContentIndex } from "./useContentIndex";

const API = getApiBaseUrl();

async function getJson(path) {
  const res = await fetch(`${API}${path}`);
  if (!res.ok) throw new Error(`Content API ${path} failed: ${res.status}`);
  return res.json();
}

export function fetchContentGitaIndex() {
  return getJson("/content/gitas/index").catch(async () => {
    const res = await fetch("/content/gita_index.json");
    if (!res.ok) throw new Error("Gita index unavailable");
    return res.json();
  });
}

export async function fetchContentGitas() {
  try {
    const data = await getJson("/content/gitas");
    return data;
  } catch {
    const idx = await fetchContentGitaIndex().catch(() => fetchContentIndex());
    if (idx?.gitas) return { gitas: idx.gitas };
    const full = await fetchContentIndex();
    return {
      gitas: Object.values(full.gitas || {}).map((g) => ({
        id: g.id,
        title: g.title,
        source: g.source,
        chapter_count_declared: g.chapter_count_declared,
        chapter_count_loaded: g.chapter_count_loaded ?? g.chapters?.length,
        verse_count: g.verse_count,
        languages_supported: g.languages_supported,
      })),
    };
  }
}

export async function fetchContentGita(id) {
  try {
    return await getJson(`/content/gitas/${encodeURIComponent(id)}`);
  } catch {
    const idx = await fetchContentIndex();
    const list = Array.isArray(idx.gitas) ? idx.gitas : Object.values(idx.gitas || {});
    const gita = list.find((g) => g.id === id) ?? idx.gitas?.[id];
    if (gita) return { gita };
    throw new Error("Gita not found");
  }
}

export function fetchContentStories() {
  return getJson("/content/stories");
}

export function fetchContentMantras() {
  return getJson("/content/mantras");
}

export function fetchContentGurus() {
  return getJson("/content/gurus");
}

export function fetchContentAsanas() {
  return getJson("/content/yoga/asanas");
}

export function fetchContentSearch(q, limit = 20) {
  return getJson(`/content/search?q=${encodeURIComponent(q)}&limit=${limit}`);
}
